module.exports = __webpack_public_path__ + "src/app/assets/images/speakers/pretty.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/speakers/pretty.jpg
// module id = 606
// module chunks = 0